import { gsap, Power0 } from "gsap";
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
export default class parallax {
  constructor() {
    this.parallaxFunc();
  }

  parallaxFunc() {
    const $uspImgArr = document.querySelectorAll('.js-parallaxPhoto');

    $uspImgArr.forEach(elm => {
      const elmImg = elm.querySelector('.photo__image');
      const rotateStartNum = elm.dataset.rotateStart;
      const rotateEndNum = elm.dataset.rotateEnd;
      const scaleNum = elm.dataset.scale;
      const yStartNum = elm.dataset.yStart;
      const yEndNum = elm.dataset.yEnd;
      const xStartNum = elm.dataset.xStart;
      const xEndNum = elm.dataset.xEnd;
      const tl_scale = gsap.timeline({
        scrollTrigger: {
          trigger: elm,
          start: 'top bottom',
          end: 'bottom top',
          scrub: 0,
        }
      });
      tl_scale.fromTo(elmImg, {
        scale: scaleNum,
        rotateX: rotateStartNum,
        x: xStartNum,
        y: yStartNum,
      }, {
        scale: scaleNum,
        rotateX: rotateEndNum,
        x: xEndNum,
        y: yEndNum,
        ease: Power0.easeNone
      });
      elm.querySelectorAll('img').forEach((img) =>
        img.addEventListener('load', () => {
          tl_scale.scrollTrigger.refresh()
        })
      );
    });
  }
}
